import { Form, message, Modal, Select } from 'antd';
import { useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import Button from '../../../components/Button/Button';
import { apiInstance } from '../../../utils/api';
const styleSheet = document.createElement('style');
styleSheet.textContent = `
  @keyframes flashText {
    0% { opacity: 1; }
    50% { opacity: 0.3; }
    100% { opacity: 1; }
  }
  .flash-text {
    animation: flashText 1.2s infinite;
    color: #DB3EB1;
  }
`;
document.head.appendChild(styleSheet);

const EmployeeCard = ({
  employee,
  requests,
  cardNumbers,
  handleInputChange,
  isNewEmployee,
  fetchData,
  reference,
  fetchCardsAndReference,
}) => {
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const buttonTimeoutRef = useRef(null);
  const [countdown, setCountdown] = useState(5);
  const [isCardOrdered, setIsCardOrdered] = useState(false);
  const [selectKey, setSelectKey] = useState(Date.now());
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isBlockModalVisible, setIsBlockModalVisible] = useState(false);
  const [blockReasons, setBlockReasons] = useState([]);
  const [selectedReasonId, setSelectedReasonId] = useState(undefined);
  const [isBlockReasonsLoading, setIsBlockReasonsLoading] = useState(false);
  const [isWithdrawModalVisible, setIsWithdrawModalVisible] = useState(false);
  const [withdrawReasons, setWithdrawReasons] = useState([]);
  const [selectedWithdrawReasonId, setSelectedWithdrawReasonId] = useState(undefined);
  const [isWithdrawReasonsLoading, setIsWithdrawReasonsLoading] = useState(false);
  const { push } = useHistory();

  let timeoutId;

  useEffect(() => {
    return () => {
      if (timeoutId) clearTimeout(timeoutId);
      if (buttonTimeoutRef.current) {
        clearTimeout(buttonTimeoutRef.current);
      }
    };
  }, []);

  useEffect(() => {
    if (isButtonDisabled && countdown > 0) {
      const timer = setInterval(() => {
        setCountdown((prev) => prev - 1);
      }, 1000);
      return () => clearInterval(timer);
    }
  }, [isButtonDisabled, countdown]);

  // Обновляем ключ при изменении карты сотрудника
  useEffect(() => {
    setSelectKey(Date.now());
  }, [employee?.RespCardNumber]);

  // useEffect(() => {
  //   fetchData();
  // }, []);

  // const requestPayload = {
  //   Subject: `СКД для ${employee.RespName + ' ' + employee.RespSurName}`,
  //   ServiceCategory: 'd948830b-47b7-4479-800e-277e7ba58de1',
  //   RespCardHolder: employee?.Id,
  //   SuContractorType: '4857f213-f264-4cc4-99e2-a234e3cb3ef b',
  //   Category: '2a92dbea-2b8c-4a63-b3f6-ea4135f981d7',
  //   Status: 'ae5f2f10-f46b-1410-fd9a-0050ba5d6c38', // Нове
  //   SuServiceSubCategory: 'a8de9bf9-6f59-44ce-b327-2f927b9c1db7',
  // };
  const requestPayload = {
    Subject: `СКД для ${employee.RespName || ''}`,
    ServiceCategory: 'd948830b-47b7-4479-800e-277e7ba58de1',
    RespCardReceiver: employee.Id,
    SuContractorType: '4857f213-f264-4cc4-99e2-a234e3cb3efb',
    Category: '2a92dbea-2b8c-4a63-b3f6-ea4135f981d7',
    Status: 'ae5f2f10-f46b-1410-fd9a-0050ba5d6c38', // Нове
    SuServiceSubCategory: 'a8de9bf9-6f59-44ce-b327-2f927b9c1db7',
  };

  const sendRequest = async () => {
    setIsButtonDisabled(true);
    try {
      const response = await apiInstance(
        `${process.env.REACT_APP_API_URL}/api/post-data?type=create-request`,
        'POST',
        requestPayload
      );

      if (!response.success) throw new Error('Помилка відправки звернення');

      console.log('Звернення успішно відправлена');

      // Показуємо сповіщення
      message.success(
        <span>
          картку замовлено, статус опрацювання звернення можна відслідковувати в розділі{' '}
          <span onClick={() => push('/requests')} style={{ color: '#DB3EB1', cursor: 'pointer' }}>
            «Звернення»
          </span>
        </span>,
        6
      );
    } catch (error) {
      console.error('Помилка:', error);
      message.error(error?.message || 'Не вдалося замовити картку');
    } finally {
    }
  };

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
    sendRequest();
    setIsCardOrdered(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const updateStatusCard = async (data, text) => {
    setIsButtonDisabled(true);
    try {
      const response = await apiInstance(
        `${process.env.REACT_APP_API_URL}/api/post-data?type=update-employee`,
        'POST',
        { ...data, Id: employee?.Id }
      );

      if (!response.success) throw new Error('Помилка вилучення карти');
      fetchCardsAndReference();
      fetchData();
      // Показуємо сповіщення
      message.success(text);
    } catch (error) {
      console.error('Помилка:', error);
      message.error('Не вдалося оновити статус картки');
    } finally {
      buttonTimeoutRef.current = setTimeout(() => {
        setIsButtonDisabled(false);
      }, 5000);
    }
  };

  const fetchBlockReasons = async () => {
    setIsBlockReasonsLoading(true);
    try {
      const response = await apiInstance(
        `${process.env.REACT_APP_API_URL}/api/crm/get-data?type=card-block-reasons`,
        'GET'
      );
      if (response && response.rows) {
        setBlockReasons(response.rows);
      }
    } catch (error) {
      console.error('Помилка завантаження причин блокування:', error);
      const fallback = [
        { value: "d72d3d60-b37d-42b3-88e8-fbca78fb82dd", displayValue: "Втрата картки" },
        { value: "0bf40dc0-e76f-4072-be16-aa2d7dc1fbdc", displayValue: "Звільнення співробітника" },
        { value: "9bc66c7a-c3fe-4674-8136-21db5483247c", displayValue: "Механічне пошкодження" }
      ];
      setBlockReasons(fallback);
    } finally {
      setIsBlockReasonsLoading(false);
    }
  };

  const handleBlockClick = async () => {
    setSelectedReasonId(undefined);
    setIsBlockModalVisible(true);
    await fetchBlockReasons();
  };

  const handleBlockConfirm = async () => {
    setIsBlockModalVisible(false);
    await updateStatusCard(
      {
        needsBlock: true,
        blockReasonId: selectedReasonId,
        cardId: selectedCard?.Id,
      },
      'Ви успішно заблокували картку'
    );
  };

  const fetchWithdrawReasons = async () => {
    setIsWithdrawReasonsLoading(true);
    try {
      const response = await apiInstance(
        `${process.env.REACT_APP_API_URL}/api/crm/get-data?type=card-withdraw-reasons`,
        'GET'
      );
      if (response && response.rows) {
        setWithdrawReasons(response.rows);
      }
    } catch (error) {
      console.error('Помилка завантаження причин вилучення:', error);
      const fallback = [
        { value: "9bbb3959-6243-46a0-bf22-48c1e008f3e0", displayValue: "Звільнення співробітника" },
        { value: "901cfb6c-c85c-4b4c-94a8-1955bfba81c0", displayValue: "Зміна посади / Переведення" }
      ];
      setWithdrawReasons(fallback);
    } finally {
      setIsWithdrawReasonsLoading(false);
    }
  };

  const handleWithdrawClick = async () => {
    setSelectedWithdrawReasonId(undefined);
    setIsWithdrawModalVisible(true);
    await fetchWithdrawReasons();
  };

  const handleWithdrawConfirm = async () => {
    setIsWithdrawModalVisible(false);
    await updateStatusCard(
      {
        needsWithdrawal: true,
        withdrawReasonId: selectedWithdrawReasonId,
        cardId: selectedCard?.Id,
      },
      'Ви успішно вилучили картку'
    );
  };

  // Находим текущую картку сотрудника
  const selectedCard = cardNumbers.find(
    (card) => card.Name === employee?.RespCardNumber?.toString()
  );
  // Проверяем статус карты для блокировки
  const isCardBlocked =
    selectedCard?.RespSCAStatus?.value !== '2ec4e1b9-b7f5-4eb2-9a83-695c9b1be716' &&
    employee?.RespCardNumber &&
    employee?.RespCardStatus?.value === '3075a30b-f6e8-45cd-990b-28399db75400';

  // Формируем список карт с учетом текущей
  const filteredCards = cardNumbers.filter(
    (card) => card.RespSCAStatus?.value === '2ec4e1b9-b7f5-4eb2-9a83-695c9b1be716'
  );

  const cardOptions = filteredCards.map((card) => ({
    value: card.Id,
    label: `${card.Name}${isCardBlocked ? ' (недоступна)' : ''}`,
    disabled: card.Id === selectedCard?.Id && isCardBlocked,
  }));

  // Add this helper function to check card status
  const hasReceivedCard = () => {
    return (
      employee?.RespCardNumber &&
      (employee?.RespCardStatus?.value === '3075a30b-f6e8-45cd-990b-28399db75400' ||
        employee?.RespCardStatus?.value === '2ec4e1b9-b7f5-4eb2-9a83-695c9b1be716')
    );
  };
  useEffect(() => {
    const isOrdered = requests.some(
      (request) =>
        employee?.Id &&
        ((request.RespCardReceiver?.value && request.RespCardReceiver.value === employee.Id) ||
          (request.RespCardHolder?.value && request.RespCardHolder.value === employee.Id)) &&
        request.Status?.value !== '6e5f4218-f46b-1410-fe9a-0050ba5d6c38' &&
        request.Status?.value !== '3e7f420c-f46b-1410-fc9a-0050ba5d6c38'
    );
    setIsCardOrdered(isOrdered);
  }, [requests, employee]);
  // Check if there is any request with the specified conditions

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <div style={{ margin: '24px 0 0 24px', height: '100%' }}>
        <div style={{ flex: 1, height: '100%' }}>
          <div className="box card-preview-box">
            {isNewEmployee ? (
              <span className="employee-box-header__title">Створення співробітника</span>
            ) : (
              <span className="employee-box-header__title">Номер картки:</span>
            )}
            <Form.Item
              name="cardNumber"
              style={{
                width: '80%',
                marginBottom: '10px',
              }}
              required
            >
              <Select
                key={selectedCard?.Id || 'empty'}
                value={selectedCard?.Id}
                options={cardOptions}
                disabled={hasReceivedCard() || isNewEmployee || cardOptions.length < 1 || isCardOrdered}
                placeholder={
                  employee?.RespCardNumber ? (
                    employee.RespCardNumber
                  ) : isCardOrdered && !isNewEmployee ? (
                    <span>Картка замовлена</span>
                  ) : (
                    <span className={cardOptions.length && !isNewEmployee ? 'flash-text' : ''}>
                      Оберіть картку
                    </span>
                  )
                }
                onChange={(value) => {
                  const selected = cardNumbers.find((card) => card.Id === value);
                  handleInputChange({
                    target: {
                      name: 'RespCardNumber',
                      value: selected?.Id,
                    },
                  });
                }}
                style={{
                  cursor: hasReceivedCard() || isNewEmployee ? 'not-allowed' : 'pointer',
                  opacity: hasReceivedCard() || isNewEmployee ? 0.6 : 1,
                }}
              />
            </Form.Item>
            <div className="card-preview__actions" style={{ flexDirection: 'column', gap: '12px' }}>
              <Button
                text="Вилучити"
                bg="green"
                onClick={handleWithdrawClick}
                block
                disabled={
                  isButtonDisabled ||
                  isNewEmployee ||
                  !hasReceivedCard() ||
                  employee?.RespCardStatus?.value === '2ec4e1b9-b7f5-4eb2-9a83-695c9b1be716'
                }
              />
              <Button
                text="Заблокувати "
                onClick={handleBlockClick}
                bg="orange"
                block
                disabled={
                  isButtonDisabled ||
                  isNewEmployee ||
                  !hasReceivedCard() ||
                  employee?.RespCardStatus?.value === '2ec4e1b9-b7f5-4eb2-9a83-695c9b1be716'
                }
              />
            </div>
          </div>
        </div>
      </div>
      <Modal
        className="success-modal"
        visible={isModalVisible}
        onCancel={handleCancel}
        footer={
          <div className="ant-btn-wrapper">
            <Button onClick={handleCancel} text="Відмінити" bg="orange" />
            <Button text="Замовити" bg="turquoise" onClick={handleOk} />
          </div>
        }
      >
        <div className="success-modal__wrapperSCA">
          <div className="text-black-medium-f22-l30">Замовити картку</div>
          <div className="text-grey-dark-normal-f16-l28">
            Вартість виготовлення Співробітники складає {reference?.PriceSCA?.price} грн з ПДВ,
            термін видачі від 5 робочих днів з моменту оплати рахунку, який буде відображено в
            розділі «Рахунки».
            <br />{' '}
            <span style={{ fontWeight: 'bold' }}>Ви підтверджуєте замовлення нової картки?</span>
          </div>
        </div>
      </Modal>

      <Modal
        className="success-modal"
        visible={isBlockModalVisible}
        onCancel={() => setIsBlockModalVisible(false)}
        footer={
          <div className="ant-btn-wrapper">
            <Button
              onClick={() => setIsBlockModalVisible(false)}
              text="Відмінити"
              bg="orange"
              disabled={isButtonDisabled}
            />
            <Button
              text="Заблокувати"
              bg="turquoise"
              onClick={handleBlockConfirm}
              loading={isButtonDisabled}
              disabled={isBlockReasonsLoading || isButtonDisabled || !selectedReasonId}
            />
          </div>
        }
      >
        <div className="success-modal__wrapperSCA">
          <div className="text-black-medium-f22-l30">Блокування картки СКД</div>
          <div className="text-grey-dark-normal-f16-l28" style={{ marginBottom: '16px' }}>
            Будь ласка, оберіть причину блокування картки:
          </div>
          <Select
            style={{ width: '100%' }}
            loading={isBlockReasonsLoading}
            value={selectedReasonId}
            onChange={setSelectedReasonId}
            options={blockReasons.map((reason) => ({
              value: reason.value,
              label: reason.displayValue,
            }))}
            placeholder="Оберіть причину"
          />
        </div>
      </Modal>

      <Modal
        className="success-modal"
        visible={isWithdrawModalVisible}
        onCancel={() => setIsWithdrawModalVisible(false)}
        footer={
          <div className="ant-btn-wrapper">
            <Button
              onClick={() => setIsWithdrawModalVisible(false)}
              text="Відмінити"
              bg="orange"
              disabled={isButtonDisabled}
            />
            <Button
              text="Вилучити"
              bg="turquoise"
              onClick={handleWithdrawConfirm}
              loading={isButtonDisabled}
              disabled={isWithdrawReasonsLoading || isButtonDisabled || !selectedWithdrawReasonId}
            />
          </div>
        }
      >
        <div className="success-modal__wrapperSCA">
          <div className="text-black-medium-f22-l30">Вилучення картки СКД</div>
          <div className="text-grey-dark-normal-f16-l28" style={{ marginBottom: '16px' }}>
            Будь ласка, оберіть причину вилучення картки:
          </div>
          <Select
            style={{ width: '100%' }}
            loading={isWithdrawReasonsLoading}
            value={selectedWithdrawReasonId}
            onChange={setSelectedWithdrawReasonId}
            options={withdrawReasons.map((reason) => ({
              value: reason.value,
              label: reason.displayValue,
            }))}
            placeholder="Оберіть причину"
          />
        </div>
      </Modal>
    </div>
  );
};

export default EmployeeCard;
